import React from 'react';
import { renderToString } from 'react-dom/server';
import { ICurrencyFormat } from 'utils/types';
import { DECIMALS_FORMATS, DISPLAY_BY } from 'utils/constants';
import { tooltipValueFormatter } from 'utils/format';
import {
  TooltipContainer,
  TooltipItem,
  TooltipColor,
  TooltipItemName,
  TooltipItemValue,
  TooltipItemTitle,
} from './Chart.styles';
import {
  getChartColor,
  NON_APP_COST,
  NON_PRODUCT_COST,
  PERCENTAGE_OF_COST,
} from '../utils';
import { colors } from '@alixpartners/ui-components';

export const singleBartooltipRenderer = ({
  tooltipBarId,
  displayType,
  format,
  highlightedSerie,
  x,
  series,
}: {
  displayType: string;
  format: ICurrencyFormat;
  highlightedSerie?: string;
  tooltipBarId: string;
  x: string;
  series: any[];
}): string => {
  let points: any[] = [];
  if (x === NON_PRODUCT_COST) {
    const nonProductSerie = series.find(
      (serie) => serie.name === NON_PRODUCT_COST
    );
    const percentageOfCostSerie = series.find(
      (serie) => serie.name === PERCENTAGE_OF_COST
    );

    points = [
      {
        name: 'Cost',
        color: colors.chartDarkGrey,
        value: nonProductSerie.data[0].y,
      },
    ];
    if (percentageOfCostSerie) {
      points.push({
        name: PERCENTAGE_OF_COST,
        color: colors.amber,
        value:
          percentageOfCostSerie.data[percentageOfCostSerie.data.length - 1].y,
        isPercentage: true,
      });
    }
  } else {
    points = series.reduce((acc, serie) => {
      const dataItem = serie.data.find((dataItem: any) => dataItem.name === x);
      if (dataItem) {
        let color = dataItem.isColumnInTooltip ? dataItem.color : serie.color;

        if (x.includes(NON_APP_COST)) {
          color = getChartColor(dataItem.contribution);
        }
        acc.push({
          name: serie.name,
          color,
          value: dataItem.y,
          isPercentage: dataItem.isPercentage,
          isColumnInTooltip: dataItem.isColumnInTooltip,
        });
      }
      return acc;
    }, [] as any[]);
  }
  let maxDecimal = DECIMALS_FORMATS[format.decimal];
  const isOnlyColumnTooltip = points.length && points[0]?.isColumnInTooltip;
  return renderToString(
    <TooltipContainer id={tooltipBarId}>
      {isOnlyColumnTooltip ? null : <TooltipItemTitle>{x}</TooltipItemTitle>}
      {points.map((point: any) =>
        point ? (
          <TooltipItem key={`${point.name}-${point.color}`}>
            <span>
              <TooltipColor color={point.color} />
              <TooltipItemName
                isHighlighted={
                  highlightedSerie ===
                  (point.isColumnInTooltip ? x : point.name)
                }
              >
                {point.isColumnInTooltip ? x : point.name}
              </TooltipItemName>
            </span>

            <TooltipItemValue>
              {tooltipValueFormatter({
                value: point.value,
                format,
                displayType: point.isPercentage
                  ? DISPLAY_BY.PERCENTAGE_OF_REVENUE
                  : displayType,
                maxDecimal,
              })}
            </TooltipItemValue>
          </TooltipItem>
        ) : null
      )}
    </TooltipContainer>
  );
};
